import { useEffect, useState } from 'react'

/**
 * useAsync
 * author: soojin.oh
 */

// hook
const useAsync = function <T>(task: Promise<T>, onError?: (err) => void) {
  const [result, setResult] = useState<T>()
  useEffect(() => void task.then(setResult).catch(onError), [task])
  return [result]
}

export default useAsync
